const clientEventId = () => {
  if (typeof window !== 'undefined' && window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const trackConversionGateEvent = (event, metadata = {}) => {
  if (!event || typeof fetch !== 'function') return;

  const payload = {
    ...metadata,
    event,
    client_event_id: clientEventId(),
    occurred_at: new Date().toISOString(),
    source: 'web',
  };

  if (typeof window !== 'undefined') {
    payload.page_path = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    payload.referrer = document.referrer || undefined;
  }

  fetch('/conversion_gate_events', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify(payload),
  }).catch(() => {});
};

export const conversionGateEventMetadata = (conversionGate = {}) => ({
  conversion_gate_assignment_id: conversionGate?.assignment_id,
  conversion_gate_run_key: conversionGate?.run_key,
  conversion_gate_variant_key: conversionGate?.variant_key,
  conversion_gate_variant_label: conversionGate?.variant_label,
  conversion_gate_stage: conversionGate?.stage,
  conversion_gate_used_count: conversionGate?.used_count,
  conversion_gate_limit_count: conversionGate?.limit_count,
  conversion_gate_remaining_count: conversionGate?.remaining_count,
  conversion_gate_pre_signup_answer_limit: conversionGate?.pre_signup_answer_limit,
  conversion_gate_initial_post_signup_answer_limit: conversionGate?.initial_post_signup_answer_limit,
  conversion_gate_recurring_free_daily_answer_allowance: conversionGate?.recurring_free_daily_answer_allowance,
});
